import * as fetcher from '@hydra/utils/fetcher';

export function fromLegacyNodeQs (nodeQs) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(nodeQs)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        searchParams.append(key, item);
      }
    } else {
      searchParams.append(key, value);
    }
  }
  return searchParams;
}

export async function getUsedKeywordsCount () {
  return fetcher.get('/api/serp/keyword-count').json();
}

export async function doSerpApiGetGeoLocationsRequest (searchParams) {
  return fetcher.get('/api/serp/geolocations', { searchParams }).json();
}

export async function getRankedKeywords (searchParams) {
  return fetcher.get('/api/serp/ranked-keywords', {
    searchParams: fromLegacyNodeQs({
      ...searchParams
    })
  }).json();
}
